import { formatSlotDate } from "@helpers/dateFormatter";

export const slotsTransformer = (data: any) => {
  return data
    .filter((entry: any) => entry.slots.length > 0)
    .map((entry: any) => ({
      slotDate: formatSlotDate(entry.date),
      slotCount: `${entry.slots.length} Slots`,
    }));
};


export const ServiceDataTransform = (data: any) => {
  if (!data) return { stage: "no_service" };

  const payload = Array.isArray(data) ? data[0] : data;
  const stageName = Object.keys(payload || {})[0];
  const response = payload?.[stageName]?.response;

  if (!stageName || !response) return { stage: "no_service" };

  switch (stageName) {
    case "next_service_date":
    case "upcoming_service":
    case "ongoing_service":
      return {
        stage: stageName,
        data: response,
      };

    default:
      return { stage: "no_service" };
  }
};

